const authentication = require('../../../react-azure-adb2c2').default;


export const eigyou_list = (value: any) => {

//   let url = `http://localhost:5000/v1/owner/documents/eigyoulist/` + value.owner_id + `/` + value.eigyou_no;
  let url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/v1/owner/documents/eigyoulist/` + value.owner_id + `/` + value.eigyou_no;

  const token = authentication.getAccessToken();
  // alert(url)
  return fetch(url, {
      method: 'get',
      // body: JSON.stringify(search),

      headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  }).then(res => res.json())
      .then(payload => ({ payload }))
      .catch(error => ({ error }));

};

export const download = (values: any) => {
// console.log(values)

    // const url = `http://localhost:5000/v1/owner/documents/download/` + values
    const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/v1/owner/documents/download/` + values

    const token = authentication.getAccessToken();

    // alert(JSON.stringify(accountinglistset))
    return fetch(url, {
        method: 'get',
        // body: JSON.stringify(accountinglistset),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(response => response.blob())
        .then(payload => ({ payload }))
        // .then(res => res.json())
        // .then(payload => ({ payload }))
        .catch(error => ({ error }));

};